module.exports = __webpack_public_path__ + "static/img/chika.6e95901.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/testimonial/chika.jpeg
// module id = 6FqY
// module chunks = 1